<template>
<div class="chapter">
<div class="inner_page">
<section class="ident pagetitre" epub:type="titlepage"><a id="pagetitre"></a>
<h1 class="ident_tit" epub:type="title"><span>The<br/>Unhiding<br/>of<br/>Elijah<br/>Campbell</span></h1>
<h2 class="ident_stit" epub:type="subtitle" role="doc-subtitle"><span>A Novel</span></h2>
<div class="auteur_ident"><span>Kelly Flanagan</span></div>
<div class="edit"><a class="url" href="http://www.ivpress.com" target="_blank"><img alt="Image" class="imagelarge_intext" id="logo" src="Images/AI_IVP_Books_G.jpg" width="120"/></a></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ident1.vue?a7551042